import React from "react";

export const PrintDocumentContext = React.createContext({
  messages: {}
});
